import {EventEmitter} from 'events';
import {CoordinateType} from '../interfaces/coordinate-type';

type MapAreaEvent = (value: CoordinateType) => void;

export const mapAreaEventEmitter = new EventEmitter();
const listeners: MapAreaEvent[] = [];

export const suscribeMapAreaEvent = (listener: MapAreaEvent) => {
  mapAreaEventEmitter.on('onMapAreEventEmit', listener);
  listeners.push(listener);
};

export const unsuscribeMapAreaEvent = () => {
  mapAreaEventEmitter.off('onMapAreEventEmit', listeners[0]);
};
